import { render, staticRenderFns } from "./RoleDist.vue?vue&type=template&id=8b7e52aa"
import script from "./RoleDist.vue?vue&type=script&lang=js"
export * from "./RoleDist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b7e52aa')) {
      api.createRecord('8b7e52aa', component.options)
    } else {
      api.reload('8b7e52aa', component.options)
    }
    module.hot.accept("./RoleDist.vue?vue&type=template&id=8b7e52aa", function () {
      api.rerender('8b7e52aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/role/RoleDist.vue"
export default component.exports